import { useRoutes } from "react-router-dom";
import Home from "../pages";

const ThemeRouter = () => {
  return useRoutes([
    {
      path: "/",
      children: [
        {
          path: "/",
          element: <Home />,
        },
      ],
    },
  ]);
};

export default ThemeRouter;
